module.exports = __webpack_public_path__ + "static/media/  (4).69c986b2.jpg";